<template></template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["product_tag","combination_config"],
  methods: {
    ...mapActions({
      get_product_tag: "change_product_tag_list", //获取产品tag
      get_product_palette: "get_product_palette", //获取产品调色板
      get_combination_list: "get_combination_list", //获取款式组合
    }),
  },
  mounted() {
    let { hot_ids, palette_config } = this.$attrs;
    if (!hot_ids || !hot_ids.length) return;
    console.log(this.$attrs,'palette_configpalette_config');
    if (this.product_tag) {
      this.get_product_tag(hot_ids.join(','));
    }
    if (palette_config) {
      this.get_product_palette(hot_ids.join(','));
    }
    if (this.combination_config) {
      this.get_combination_list({
        'filter[product_ids]': hot_ids.join(','),
        combination_position: "products"
      })
    }
  },
};
</script>